<template>
  <div v-if="loading">
    <v-card shaped>
      <v-skeleton-loader type="table" class="mx-auto">
      </v-skeleton-loader>
    </v-card>
  </div>
  <div v-else>
    <v-card shaped>
      <v-card-title>
        <v-row class="d-flex justify-space-between align-center">
          <v-col>
            Attendees
          </v-col>
          <v-col>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="pt-0 pb-0">
        <v-row>
          <v-col>
            <v-switch 
              inset
              label="Hide Checked In"
              v-model="hideCheckedIn"
            ></v-switch>
          </v-col>
        </v-row>
      </v-card-text>
      <v-data-table
        :items="attendees"
        :headers="headers"
        :search="search"
        :loading="loadingAttendees"
        group-by="Session"
        :show-group-by="false"
      >
        <template v-slot:item.isCheckedIn="{ item }">
          <v-simple-checkbox
            v-model="item.isCheckedIn"
            disabled
          ></v-simple-checkbox>
        </template>
        <template v-slot:item.avatar="{ item }" >
          <Avatar :employee="item" :size="30" :hideHeadline="true" />
        </template>
        <template v-slot:item.fields.Name="{ item }" >
          <router-link 
            :to="{ name: 'Employee', params: { id: item.id } }"
          >
          {{ item.fields.Name }}
          <v-chip 
            v-if="item.fields.Status === 'Inactive'" 
            x-small
            class="ml-1 text-uppercase"
            color="error"
          >
            inactive
          </v-chip>
          </router-link>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
  import moment from 'moment'
  import Avatar from '@/components/employee/Avatar'

  export default {
    name: 'curriculumAttendees',
    props: {
      sessions: Array,
      loading: Boolean
    },
    components: {
      Avatar
    },
    data () {
      return {
        hideCheckedIn: false,
        showGrouping: true,
        loadingAttendees: true,
        search: '',
        headers: [
          {
            text: 'Checked In',
            align: 'center',
            sortable: false,
            value: 'isCheckedIn'
          },
          {
            text: '',
            sortable: false,
            value: 'avatar'
          },
          {
            text: 'Name',
            align: 'start',
            sortable: true,
            value: 'fields.Name'
          },
          {
            text: 'Email',
            align: 'start',
            sortable: true,
            value: 'fields.Email'
          },
          {
            text: 'Department',
            align: 'start',
            sortable: true,
            value: 'fields.Department'
          },
          {
            text: 'Location',
            align: 'start',
            sortable: true,
            value: 'fields.Location Formatted'
          }
        ]
      }
    },
    computed: {
      sessionIds () {
        return this.sessions.map(s => {
          return s.id
        })
      },
      employees () {
        return this.$store.getters.getEmployees
      },
      attendees () {
        let attendees = this.employees.filter(e => {
          if (e.fields.Sessions) {
            return this.sessions.find(s => {
              return e.fields.Sessions.includes(s.id)
            })
          }
        }).map(e => {
          const session = this.sessions.find(s => {
            return e.fields.Sessions.includes(s.id)
          })
          if (session) {
            e.sessionRecord = session
            e.isCheckedIn = session.fields['Checked In'] ? 
                            session.fields['Checked In'].includes(e.id) :
                            false
            e.Session = session.fields.Name + ' - ' +
                        moment(session.fields.Start).format('MM/DD/YYYY')
            return e
          }
        }).sort((a, b) => {
          const aStart = a.sessionRecord.fields.Start
          const bStart = b.sessionRecord.fields.Start
          return aStart > bStart ? 1 : -1
        })
        if (this.hideCheckedIn) {
          attendees = attendees.filter(e => {
            return !e.isCheckedIn
          })
        }
        return attendees
      }
    },
    created () {
      this.$store.dispatch('getRecords', {
        table: 'Employees',
        view: 'All Employees',
        dispatch: 'setEmployees'
      })
      .then(() => {
        this.loadingAttendees = false
      })
    }
  }
</script>
